import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function setDeliveryDate({
    deliveryDate,
    deliveryId,
    reference,
}: SetDeliveryMethodArguments) {
    if (!reference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    const url = getUrl(`/baskets/${reference}/update/deliverydate/${deliveryId}`);

    if (deliveryDate) {
        url.searchParams.set('deliveryDate', deliveryDate.toDateString());
    }

    return shop.post(url).json<ShopTypes.BasketResponse>();
}

interface SetDeliveryMethodArguments {
    deliveryDate?: Date;
    deliveryId: number;
    reference: string | undefined;
}
